export default __webpack_public_path__ + "d65ea7a520ffc32da69ceb02400d6678.svg";